import Fetch from "@/utils/Fetch";
import { AccountManager, ResultResponse } from "@/interfaces/api/models";

/**
 * The signed-in tenant's account manager (the token decides the tenant). The answer is in `Result`,
 * which is null when none is assigned or Manager is unreachable (still HTTP 200).
 */
const getAccountManager = async (): Promise<ResultResponse<AccountManager>> => {
    return await Fetch.get({
        url: "/AccountManager/Get",
    });
};

export default {
    getAccountManager,
};
